import request from '@/utils/httpRequest'

export default class ResourcesService {
    queryById (id) {
        return request({
            url: '/contract/shyeLeasingResources/queryById',
            method: 'get',
            params: {id: id}
        })
    }

    startFlow (params) {
        return request({
            url: '/contract/shyeLeasingResources/startFlow',
            method: 'post',
            data: params
        })
    }
    queryByhouseId(id) {
        return request({
            url: '/base/wuyeBaseHouse/queryById',
            method: 'get',
            params: {id: id}
        });
    }
}
